const isWeb = true;
import { AntiReqTool } from '@nibfe/h5guard-request';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { request as maxRequest } from '@max/meituan-uni-network';
import { getAppVersion, PlatformType, getPlatformType, getSystemType, SystemType } from '@nibfe/mkt-env-api';
import { getRiskParams } from '@nibfe/mkt-risk-api';
export const AJAX_ERROR_NAME = '网络错误';
const API_MAP = {
    PROD: 'https://ihotel.meituan.com'
};
export var Source;
(function (Source) {
    Source[Source["MEITUAN_APP"] = 1] = "MEITUAN_APP";
    Source[Source["DIANPING_APP"] = 2] = "DIANPING_APP";
    Source[Source["WECHAT_MEITUAN_MINI"] = 3] = "WECHAT_MEITUAN_MINI";
    Source[Source["WECHAT_HOTEL_MINI"] = 4] = "WECHAT_HOTEL_MINI";
    Source[Source["WECHAT_DIANPING_MINI"] = 5] = "WECHAT_DIANPING_MINI";
})(Source || (Source = {}));
export function getSource() {
    const platformType = getPlatformType();
    switch (platformType) {
        case PlatformType.mtApp:
        case PlatformType.mtAppWebView:
            return Source.MEITUAN_APP;
        case PlatformType.dpApp:
        case PlatformType.dpAppWebView:
            return Source.DIANPING_APP;
        case PlatformType.mtMinaWebview:
            return Source.WECHAT_MEITUAN_MINI;
        case PlatformType.mtHotelMinaWebview:
            return Source.WECHAT_HOTEL_MINI;
        case PlatformType.dpMinaWebview:
            return Source.WECHAT_DIANPING_MINI;
        default:
            return Source.MEITUAN_APP;
    }
}
export function useRequest(path) {
    const ctx = useMonitorEngineContext();
    const request = async (params) => {
        try {
            const { uuid, platform, userId, token, lat, lng } = ctx._runtimeInfo.commonParams;
            let finalRequestParams = params;
            try {
                const antiReq = new AntiReqTool({
                    autoFillParams: true
                });
                finalRequestParams = antiReq.addCommonParams(finalRequestParams);
            }
            catch {
                ctx._raptorReport.monitorReportLog('请求加上反爬参数错误', '请求加上反爬参数错误', {
                    level: 'warn',
                    category: 'jsError'
                });
            }
            const url = `${API_MAP.PROD}${path}`;
            let riskParams = {};
            try {
                riskParams = await getRiskParams(2);
            }
            catch (e) {
                // empty
            }
            const version = getAppVersion();
            const riskRequest = {
                ...riskParams,
                uuid,
                version,
                expoId: ctx._runtimeInfo.queryParams.expoId || '',
                latitude: Number.isNaN(Number(lat)) ? 0 : Number(lat),
                longitude: Number.isNaN(Number(lng)) ? 0 : Number(lng)
            };
            const response = await new Promise((resolve, reject) => {
                maxRequest({
                    url,
                    data: {
                        ...finalRequestParams,
                        riskRequest,
                        userId: Number(userId),
                        token,
                        platform: platform === 'dp' ? 2 : 1,
                        source: getSource(),
                        pageSource: ctx._runtimeInfo.queryParams.pageSource || '',
                        cityId: Number(ctx._runtimeInfo.cityId) || 0,
                        locateCityId: Number(ctx._runtimeInfo.cityId) || 0,
                        latitude: Number.isNaN(Number(lat)) ? 0 : Number(lat),
                        longitude: Number.isNaN(Number(lng)) ? 0 : Number(lng),
                        uuid,
                        version
                    },
                    method: 'POST',
                    header: {
                        'content-type': 'application/json',
                        token: token || ''
                    },
                    _meituan: {
                        requestType: 'MRNUtils',
                        mrnChannel: 'hotel'
                    },
                    success(res) {
                        ctx._raptorReport.monitorReportNetworkSuccess?.({
                            apiPath: path
                        });
                        if (res?.data?.status === 0) {
                            resolve(res?.data?.data);
                        }
                        else {
                            const error = new Error(AJAX_ERROR_NAME);
                            error.name = AJAX_ERROR_NAME;
                            error.message = '请求接口异常-code非0';
                            ctx._raptorReport.monitorReportLog?.('接口请求异常', error, {
                                level: 'info',
                                category: 'ajaxError'
                            });
                            reject(error);
                        }
                    },
                    fail(error) {
                        ctx._raptorReport.monitorReportNetworkFailed?.({
                            apiPath: path
                        });
                        if (typeof error === 'object') {
                            error.name = AJAX_ERROR_NAME;
                            error.message = '请求接口异常-网络异常';
                        }
                        ctx._raptorReport.monitorReportLog?.('接口请求异常', error, {
                            level: 'info',
                            category: 'ajaxError'
                        });
                        reject(error);
                    }
                });
            });
            return response;
        }
        catch (err) {
            if (err instanceof Error && err.name !== AJAX_ERROR_NAME) {
                ctx._raptorReport.monitorReportLog?.(err.message, err, {
                    level: 'error',
                    category: 'jsError'
                });
            }
            return null;
        }
    };
    return {
        request
    };
}
export const IS_IOS = getSystemType() === SystemType.ios;
export const IS_ANDROID = getSystemType() === SystemType.android;
